'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import ErrorState, { ErrorStateProps } from '@/app/(main)/_components/error-state/error-state';
import { RetryableSearchError, SearchErrorType } from '@/app/(main)/(pages)/busca/[slug]/_utils/search-error.util';

const searchErrorContent: Record<RetryableSearchError, { title: string; description: string }> = {
  [SearchErrorType.SERVER]: {
    title: 'Não conseguimos carregar sua busca',
    description: 'Tivemos um problema por aqui. Tente novamente em instantes.',
  },
  [SearchErrorType.OFFLINE]: {
    title: 'Sem conexão com a internet',
    description: 'Verifique sua conexão e tente novamente.',
  },
};

interface SearchErrorProps {
  type: RetryableSearchError;
  onRetry: () => void;
  titleAs?: ErrorStateProps['titleAs'];
}

export default function SearchError({ type, onRetry, titleAs }: SearchErrorProps) {
  const { title, description } = searchErrorContent[type];

  return (
    <div data-testid={DataTestIdEnum.SEARCH_ERROR}>
      <ErrorState title={title} titleAs={titleAs} description={description} onReset={onRetry} />
    </div>
  );
}
